import { render, staticRenderFns } from "./pasteDg.vue?vue&type=template&id=fdaa948e&scoped=true&"
import script from "./pasteDg.vue?vue&type=script&lang=js&"
export * from "./pasteDg.vue?vue&type=script&lang=js&"
import style0 from "./pasteDg.vue?vue&type=style&index=0&id=fdaa948e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdaa948e",
  null
  
)

export default component.exports